export {
  ACCESS_LEVEL,
  LIFECYCLE_STAGES,
  SERIES_ACTION_TYPES,
  GAME_ACTION_TYPES,
} from '~/components/CommonConstants';

export const SERIES_TO_USER_LEVEL_PERMISSION_KEYS = {
  MODULE_MANAGEMENT: 'MODULE_DEVELOPMENT',
} as { [key: string]: string };
